import React from 'react';
import ReactApexChart from "react-apexcharts";

function MultiAxisLineChart({ width, height, data }) {
  if (!data || !data.series || !Array.isArray(data.series)) {
    return <div>Use Another favorite prompt to generate</div>;
  }

  try {
    return (
      <ReactApexChart
        options={data}
        series={data.series}
        type="line"
        height={height}
        width={width}
      />
    );
  } catch (error) {
    console.error("Chart rendering error:", error);
    return <div>Error: Failed to render chart. Use Another favorite prompt to generate</div>;
  }
}

export default MultiAxisLineChart;
